import React from "react";
import SiteChrome from "./sitechrome";

/**
 * HeaderTwo — 전역 SiteChrome(관리 페이지 헤더 + 하단 상담 CTA 바)으로 교체됨.
 * 구 구현(fixed 82px 헤더 + MUI 드로어)은 header2_backup.tsx에 보존.
 * hideBottomMenu 등 props는 기존 페이지 호환을 위해 시그니처만 유지하고 무시한다.
 */
const HeaderTwo: any = (props: any) => <SiteChrome />;

export default HeaderTwo;
